/* eslint-disable key-spacing */
export const defaultTagsTheme = {
  closeIcon:                  'tags-icon',
  defaultIcon:                'icon-default',
  tag:                        'tags-item',
  wrapper:                    'tags-wrapper',
};
/* eslint-enable key-spacing */
